import { Component, h } from "preact";
import { IConfiguration } from "../../../typings";

export default class ISliderControl extends Component<
  ISliderControlProps,
  any
> {
  constructor(props: ISliderControlProps) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(): void {
    this.props.onClick();
  }

  render(): JSX.Element {
    return (
      <div
        className={
          "slider__control js-slider-control " +
          (this.props.active === false ? "slider__control--disabled" : "")
        }
        onClick={this.onClick}
      >
        <svg className="icon icon--angle-circle" role="img">
          <use
            xlinkHref={
              this.props.config.asset_prefix +
              "assets/img/icons-sprite.svg#angle-circle"
            }
          />
        </svg>
      </div>
    );
  }
}

interface ISliderControlProps {
  onClick: Function;
  active: boolean;
  small: boolean;

  config: IConfiguration;
}
